


















// vendor
import { defineComponent, PropType, computed, ref } from "@vue/composition-api";
// local
import { FormItem, Dropdown, DataChannel } from "../../ts/types";
import ErrorOverlay from "./error-overlay.vue";
import ErrorBox from "./error-box.vue";

export default defineComponent({

	emits:[ "input" ],
	props:{
		value:{
			type:Number
		},
		config:{
			type:Object as PropType<FormItem<Dropdown>>,
			required:true
		}
	},
	components:{
		ErrorOverlay,
		ErrorBox
	},
	setup(props, context){

		const pristine = ref(true);

		const val = computed({
			get:() => props.value,
			set:v => context.emit("input", v)
		});

		const state = computed(() => val.value !== undefined && val.value > -1);

		const isValid = () => {
			pristine.value = false;
			return state.value;
		};

		const getChannels = (prefix:string):DataChannel<number>[] => {
			const v = val.value;
			return v !== undefined ? [
				{
					key: prefix,
					data:v
				}
			] : [];
		};

		const displayOptions = computed(() => {
			return [
				{ value: -1, text: "--", disabled: !props.config.optional },
				...props.config.settings.options.map((o, i) => { return { value:i, text:o }; })
			]
		});

		const init = () => {
			if(val.value === undefined){ val.value = -1; }
		};

		init();

		return {
			pristine,
			state,
			val,
			displayOptions,
			isValid,
			getChannels
		};
	}
});
